import * as React from 'react'
import { styles } from './useStyles'
import { Logo } from './Logo'
import Box from '@mui/material/Box'

type Props = {
  children: React.ReactNode
}

export function DialogToolbar(props: Props) {
  const { children } = props

  return (
    <Box
      sx={{
        ...styles.toolbar,
        ...styles.toolbarSettings,
      }}
    >
      <Logo colorful={false} style={{ width: '167px', height: '43px' }} />
      <Box sx={styles.spacer} />
      {children}
    </Box>
  )
}
